
    var refs = 0;
    var css = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../node_modules/postcss-loader/dist/cjs.js??ref--7-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--7-3!./LoaderPage.scss");
    var insertCss = require("!../../../../node_modules/isomorphic-style-loader/insertCss.js");
    var content = typeof css === 'string' ? [[module.id, css, '']] : css;

    exports = module.exports = css.locals || {};
    exports._getContent = function() { return content; };
    exports._getCss = function() { return '' + css; };
    exports._insertCss = function(options) { return insertCss(content, options) };

    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (module.hot && typeof window !== 'undefined' && window.document) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../node_modules/postcss-loader/dist/cjs.js??ref--7-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--7-3!./LoaderPage.scss", function() {
        css = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../node_modules/postcss-loader/dist/cjs.js??ref--7-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--7-3!./LoaderPage.scss");
        content = typeof css === 'string' ? [[module.id, css, '']] : css;
        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  